import { render } from "./PrivacyPage.vue?vue&type=template&id=4746f4e9&scoped=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"

import "./PrivacyPage.vue?vue&type=style&index=0&id=4746f4e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4746f4e9"]])

export default __exports__